import type { MvcLead } from "@repo/models";
import type { GridList } from "@repo/ui";
import type { SortBy } from "@repo/ui/grid/types";

import type { LeadsSetting } from "../models/setting";
import { BaseController } from "./baseController";

export interface LeadsFilter {
	startDate: Date | undefined;
	endDate: Date | undefined;
	currentPage?: number;
	itemsPerPage?: number;
	brands?: number[];
	channels?: number[];
	marketers?: number[];
	states?: number[];
	branches?: number[];
	repFirstName?: string;
	repLastName?: string;
	repLogin?: string;
	customerFirstName?: string;
	customerLastName?: string;
	converted?: boolean;
	sortBy?: SortBy;
	leadId?: number;
}

const controller = import.meta.env.MODE === "development" ? "MVC/Leads" : "Leads";

export class LeadsController extends BaseController {
	static Get = BaseController.GetFn(controller);
	static async getSettings(leadId: number) {
		const params = { leadId };

		return await LeadsController.Get<LeadsSetting>("GetSettings", params);
	}

	static async getLeads(filters: LeadsFilter) {
		const params = {
			...filters,
		};

		return await LeadsController.Get<GridList<MvcLead>>("GetLeads", params);
	}

	static async getLeadsForExport(filters: LeadsFilter) {
		const params = {
			...filters,
			export: true,
		};

		return await LeadsController.Get<GridList<MvcLead>>("GetLeads", params);
	}
}
